import { Component } from '@angular/core';
import { BaseMainMenuComponent } from '../base/base-main-menu.component';

@Component({
  selector: 'lbt-mobile-main-menu',
  standalone: false,
  templateUrl: './mobile-main-menu.component.html',
  styleUrl: './mobile-main-menu.component.scss',
})
export class MobileMainMenuComponent extends BaseMainMenuComponent {
}
